import type { RouteRecordRaw, Router } from 'vue-router'

const BranchRoutes: RouteRecordRaw = {
  path: '/branch',
  name: 'BranchModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageBranchesRoute',
      component: () => import('./views/ManageBranchesView.vue'),
      meta: {
        title: 'branch.branches',
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BranchRoutes)
}
